export const DefaultBreadcrumbSubTitle = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: " class.",
  },
];

export const DividerBreadcrumbSubTitle = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb-icon",
  },
  {
    text: " class.",
  },
];

export const WithIconBreadcrumbSubTitle = [
  {
    text: "You can set icons breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: "class.",
  },
];

export const VariationBreadcrumbSubTitle = [
  {
    text: "You can set variations breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: "class through any icons sets.",
  },
];

export const ColorBreadcrumbSubTitle = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: " class and set background colors like ",
    code: "[.bg-*].",
  },
];

export const ColoredBreadcrumbData = [
  {
    id: 1,
    color: "info",
    item: ["Home", "Bonus Ui", "Breadcrumb"],
  },
  {
    id: 2,
    color: "warning",
    item: ["Home", "Icons", "Flag-icon"],
  },
  {
    id: 3,
    color: "danger",
    item: ["Home", "Gallery", "Gallery-grid"],
  },
];
